import axiosClient from "./axiosClient";
import { apiPath } from '../../utils/api-contants';
import { isEmpty } from "lodash";
import { menuList } from "../../utils/route-paths";

const settings = {
  fetchSettings: async (token: string) => {
    try {      
      // const defaultConfig: any =
      // {
      //   config: {
      //     background_color: '#F8FAFB',
      //     primary_color: "#5C85FF",
      //     secondary_color: "#FFFFFF",
      //     text_color: "#434D67",
      //     font_changes: {
      //       font_name: "Default",
      //       cdn_url: "Default"
      //     },
      //     things_machines: {
      //       entity_name: "Machine",
      //       page_name: "Machinery Management",
      //     },
      //     things_parts: {
      //       entity_name: "Part",
      //       page_name: "Part Management",
      //     },
      //     things_gateways: {
      //       entity_name: "Gateway",
      //       page_name: "Gateway Management"
      //     },
      //     site_factory: {
      //       entity_name: "Factory",
      //       page_name: "Factory Management"
      //     }
      //   },
      //   status: "noinput"
      // };

      const apiResponse: any = await axiosClient.get(apiPath.SETTING_SERVICE_BASE_URL);
      const res: any = apiResponse.data
      return {
        status: 'success',
        res: res //!isEmpty(res) ? isEmpty(apiResponse.config) ? defaultConfig : apiResponse.data : apiResponse.data
      };
    } catch (error) {
      return {
        status: 'error',
        error,
      };
    }
  },
  saveSettings: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.put(apiPath.SETTING_SERVICE_BASE_URL, payload);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        data: {}
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updateSettings: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.put(apiPath.SETTING_SERVICE_BASE_URL, payload);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        data: {}
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchMenu: async (payload: any) => {
    try {
     const _static :any = menuList;
      // const apiResponse: any = await axiosClient.get(apiPath.SETTING_SERVICE_BASE_URL, payload);
      // const res: any = apiResponse.data;
      return {
        status: 'success',
        code: 200, //apiResponse?.status,
        data: _static
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },

}

export default settings;